// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "@rescript/react/src/React.bs.js";

var make = React.lazy_(function () {
      return import("./ACHBankTransfer.bs.js").then(function (m) {
                  return m.default;
                });
    });

export {
  make ,
}
/* make Not a pure module */
